import React, { useMemo, useRef, useState } from 'react';
import styles from '../user-profile/userProfile.module.scss';
import IconDown from '../../../assets/icons/chevron_down.svg?react';
import { useOnClickOutside } from '../../../hooks/useClickOutside';
import { useAuthToken } from 'src/hooks/useAuthToken';

type DropDownText = {
  logout: string;
};

type Props = {
  isMobile: boolean;
  menuText: DropDownText;
};

function ParentUserProfile(props: Props) {
  const { isMobile, menuText } = props;

  const [showMenu, setShowMenu] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { removeParentAuthToken, parentData } = useAuthToken();

  useOnClickOutside(wrapperRef, () => handleCloseMenu());

  const handleLogout = () => {
    handleCloseMenu();
    removeParentAuthToken();
    // eslint-disable-next-line no-restricted-globals
    location.href = "/";
  };

  const handleToggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleCloseMenu = () => {
    setShowMenu(false);
  };

  const classes = useMemo(() => {
    const classes = [styles.wrapper];
    if (showMenu) {
      classes.push(styles.open);
    }
    return classes.join(" ");
  }, [showMenu]);

  if (isMobile) {
    return (
      <div ref={wrapperRef} className={classes} onClick={handleToggleMenu}>
        <div className={styles.content}>
          <div className={styles.iconWrapper}>
            <IconDown />
          </div>
        </div>
        <ul className={styles.list}>
          <li className={styles.listItem} onClick={handleLogout}>
            {menuText.logout}
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div ref={wrapperRef} className={classes} onClick={handleToggleMenu}>
      <div className={styles.content}>
        <div
          className={styles.name}
          title={parentData?.email?.toUpperCase() || "No Email"}
        >
          <span className={styles.nameInner}>
            {parentData?.email?.toUpperCase() || "No Email"}
          </span>
        </div>
        <div className={styles.iconWrapper}>
          <IconDown />
        </div>
      </div>
      <ul className={styles.list}>
        <li className={styles.listItem} onClick={handleLogout}>
          {menuText.logout}
        </li>
      </ul>
    </div>
  );
}

export default ParentUserProfile;
